import { Stack, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { AxiosError } from 'axios';
import { StatusCodes } from 'http-status-codes';

import BackdropLoading from '@shared/components/backdrop-loading';
import logomb from '@assets/logo-ministerio-belem.png';
import { ApiErrorResponse } from '@shared/types/api-error-response';
import { getTransferLetter } from '@features/secretary/services/transfers.service';

export default function LetterRecommendationView() {
  const { letterId } = useParams();

  const { data, isFetching, error } = useQuery(
    ['letter', letterId],
    () => getTransferLetter(letterId ?? ''),
    { retry: false, refetchOnWindowFocus: false },
  );

  const axiosError = error as AxiosError<ApiErrorResponse>;

  const isExpired = axiosError?.response?.data.statusCode === StatusCodes.GONE;

  function getTitleByError() {
    if (isExpired) return 'Carta de Recomendação Inválida!';
    return 'Carta de Recomendação Não Encontrada';
  }

  function getDescriptionByError() {
    if (isExpired)
      return 'Este documento passou do prazo de validade. Por favor, procurar um responsável pela validação do mesmo, ou faça uma nova solicitação.';
    return 'Desculpe, o documento solicitado não pôde ser encontrado. Por favor, verifique se o link está correto e tente novamente.';
  }

  return (
    <Stack height="100vh" sx={{ backgroundColor: 'Ambient/Base/White' }}>
      <BackdropLoading isOpen={isFetching} />

      {data?.url ? (
        <object
          data={data?.url}
          type="application/pdf"
          width="100%"
          height="100%"
        />
      ) : null}

      {!data?.url && !isFetching ? (
        <Stack alignItems="center" justifyContent="center" height="100%">
          <Stack width={113}>
            <img src={logomb} style={{ width: '100%' }} />
          </Stack>

          <Stack
            width={550}
            border="1px solid"
            borderColor="Feedback/Erro"
            borderRadius={2}
            py={4}
            px={10}
            mt={3}
            textAlign="center"
            sx={{ backgroundColor: 'Ambient/Deep/White' }}
          >
            <Stack alignItems="center" mb={3}>
              <ErrorOutlineIcon
                fontSize="large"
                sx={{ color: 'Interaction/Feedback/Erro' }}
              />
            </Stack>

            <Typography
              variant="Headlines/XLarge"
              color="Interaction/Feedback/Erro"
              fontSize={24}
              fontWeight={500}
            >
              {getTitleByError()}
            </Typography>

            <Typography
              variant="Headlines/Medium"
              color="Ambient/Grayscale/Gray-300"
              fontSize={24}
              fontWeight={300}
              mt={2}
            >
              {getDescriptionByError()}
            </Typography>
          </Stack>
        </Stack>
      ) : null}
    </Stack>
  );
}
